import React from 'react';
import { styled } from '@mui/material/styles';
import { tUi } from '../../../../../../../../../utils/dq_lc';
import { HtmlContentColumn, HtmlContentWrapper, SlideTitle } from '../../../../../../styles/LearnTab/slideBase.styles';
import { CaseSectionStack, CaseSection } from './CaseStudyCard.styles';
import { LabChipRow, LabChip, LabPredict } from './HandsOnLabCard.styles';
import { inline, listOf, textOf } from './HandsOnLabCard.comp';

// Before you start: one self-study slide at the end of the session intro. Each concept the session builds on gets
// a short explanation and a phrase to search for. The slide shows no outside links.
// For young learners (audience "child") there are no search phrases, the text is larger and a grown-up reads along.
const MAX_ITEMS = 5;

const PrepStack = styled(CaseSectionStack)`
  & > [data-prep-header] {
    text-align: left;
  }

  [data-prep-search] {
    display: inline-block;
    margin-top: 8px;
  }

  [data-prep-audience='child'] & [data-prep-item],
  [data-prep-audience='child'] & [data-prep-intro] {
    font-size: 20px;
    line-height: 1.6;
  }
`;

export const PrepGuideCard = ({ slide, uiLocale = 'en-US' }) => {
  const origin = slide?._pbdq_origin || slide || {};
  const child = textOf(origin.audience) === 'child';
  const items = listOf(origin.items).filter((item) => textOf(item?.term)).slice(0, MAX_ITEMS);
  const minutes = Number(origin.self_study_minutes);
  const localTitle = tUi('slide.prep.title', uiLocale);
  const title = localTitle !== 'slide.prep.title' ? localTitle : textOf(origin.headline);
  const badge = Number.isFinite(minutes) && minutes > 0
    ? tUi('slide.prep.badge', uiLocale, { n: minutes })
    : tUi('slide.prep.badgeNoTime', uiLocale);

  return (
    <HtmlContentColumn data-prep-guide data-prep-audience={child ? 'child' : 'default'}>
      {title && <SlideTitle>{title}</SlideTitle>}
      <HtmlContentWrapper>
        <PrepStack>
          <div data-prep-header>
            <LabChipRow>
              <LabChip data-prep-badge>{badge}</LabChip>
            </LabChipRow>
            {textOf(origin.intro_line) && <div data-prep-intro>{inline(origin.intro_line)}</div>}
            {child && <LabPredict data-prep-grownup>{tUi('slide.prep.withGrownUp', uiLocale)}</LabPredict>}
          </div>
          {items.map((item, idx) => {
            const search = child ? '' : textOf(item.search_phrase);
            return (
              <CaseSection key={idx} data-prep-item>
                <strong>{inline(item.term)}</strong>
                {textOf(item.explanation) && <div>{inline(item.explanation)}</div>}
                {search && <LabChip data-prep-search>{tUi('slide.prep.search', uiLocale, { phrase: search })}</LabChip>}
              </CaseSection>
            );
          })}
        </PrepStack>
      </HtmlContentWrapper>
    </HtmlContentColumn>
  );
};

export default PrepGuideCard;
